"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNodeIntermediate = exports.isNode = exports.hasArtifactTypeIntermediate = exports.typeGuardIntermediate = exports.isIntermediateNodeConfig = exports.isNodeConfig = exports.hasArtifactType = exports.typeGuard = exports.artifactType = exports.cloneFromTemplateArtifact = void 0;
const typeguards_1 = require("../typeguards");
const node_1 = require("./node");
Object.defineProperty(exports, "artifactType", { enumerable: true, get: function () { return node_1.artifactType; } });
var clone_1 = require("./clone");
Object.defineProperty(exports, "cloneFromTemplateArtifact", { enumerable: true, get: function () { return clone_1.cloneFromTemplateArtifact; } });
const { isNodeConfig, typeGuard, hasArtifactType } = (0, typeguards_1.createZodTypeGuards)(node_1.NodeConfigSchema, node_1.NodeTypeSchema, node_1.artifactType);
exports.isNodeConfig = isNodeConfig;
exports.typeGuard = typeGuard;
exports.hasArtifactType = hasArtifactType;
// this is special node where intermediate node config is
// different than the final db config
const { isNodeConfig: isIntermediateNodeConfig, typeGuard: typeGuardIntermediate, hasArtifactType: hasArtifactTypeIntermediate, } = (0, typeguards_1.createZodTypeGuards)(node_1.IntermediateNodeConfigSchema, node_1.IntermediateNodeSchema, node_1.artifactType);
exports.isIntermediateNodeConfig = isIntermediateNodeConfig;
exports.typeGuardIntermediate = typeGuardIntermediate;
exports.hasArtifactTypeIntermediate = hasArtifactTypeIntermediate;
/** @deprecated Use hasArtifactType. */
exports.isNode = hasArtifactType;
/** @deprecated Use hasArtifactTypeIntermediate. */
exports.isNodeIntermediate = hasArtifactTypeIntermediate;
//# sourceMappingURL=index.js.map